export const convertArrayToString = (array: string[]): string =>
  array.join(', ');
